import axios, { AxiosRequestConfig } from "axios";
import getAxiosConfig from "../other/axiosConfig";

const getConversationsApi = async () => {
  try {
    const config: AxiosRequestConfig = getAxiosConfig(
      "GET",
      "/webchat/get-conversation",
      "bearer",
    );

    const response = await axios(config);

    if (response.data) {
      if (response.data.code === 200)
        if (response.data.data) {
          const { conversation } = response.data.data;

          return conversation;
        }
    }

    return [];
  } catch (error) {
    return error;
  }
};

export default getConversationsApi;
